import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { QUERY_KEYS } from '@hero/constants';
import { recognitionServices } from '@hero/services';
import { useNotification } from '@hero/store/hooks';

export const useSubmitToApproval = ({ options = {} } = {}) => {
  const queryClient = useQueryClient();
  const { showSuccess } = useNotification();
  const { t } = useTranslation();

  return useMutation(
    ({ code, approvalType }) => recognitionServices.submitToApproval({ code, approvalType }),
    {
      ...options,
      onSuccess: (_data, variables) => {
        queryClient.invalidateQueries({
          queryKey: [QUERY_KEYS.useGetRecognitionsKey],
          refetchType: 'active'
        });
        queryClient.invalidateQueries({
          queryKey: [QUERY_KEYS.useGetRecognitionKey, variables.code],
          refetchType: 'active'
        });

        showSuccess({
          message: t('successfullySentApproveToFacilityMessage'),
          type: 'toast'
        });
      }
    }
  );
};
